import { useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  createFileRoute,
  useParams,
  useNavigate,
  useSearch,
} from '@tanstack/react-router';

import { Dialog } from '@mui/material';

import { useAuthStore, useObtainTokenFromEmailToken } from '@features/auth';

type SearchParams = {
  venue?: string;
};

const CodeView = () => {
  const { email, token } = useParams({
    from: '/_auth/auth/token/$email/$token',
  });
  const { venue: venueSlug } = useSearch({
    from: '/_auth/auth/token/$email/$token',
  }) as SearchParams;
  const navigate = useNavigate();

  const { mutateAsync } = useObtainTokenFromEmailToken({
    email,
    auth_token: token,
  });

  useEffect(() => {
    if (email && token) {
      mutateAsync(
        {
          email,
          auth_token: token,
        },
        {
          onSuccess: (data) => {
            useAuthStore.getState().setTokens({
              accessToken: data.access,
              refreshToken: data.refresh,
            });
            const isStaff = useAuthStore.getState().isStaff;
            if (isStaff) {
              navigate({ to: '/staff' });
            } else if (venueSlug) {
              navigate({
                to: '/$venueSlug',
                params: { venueSlug },
              });
            } else {
              navigate({ to: '/' });
            }
          },
          onError: (error) => {
            toast.error('Invalid auth token or token has expired.');
            console.log('error', error);
          },
        }
      );
    }
  }, [email, token, venueSlug, mutateAsync, navigate]);

  return <Dialog open={true} scroll={'body'} fullWidth={true}></Dialog>;
};

export const Route = createFileRoute('/_auth/auth/token/$email/$token')({
  component: CodeView,
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    return {
      venue: search.venue as string | undefined,
    };
  },
});
